import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  input,
  InputSignal,
  Output,
  ViewChild
} from '@angular/core';
import {CodesReelModel} from '../../models/codes-reel.model';
import {PriceFormatPipe} from '../../helpers/pipes/price-format';
import {UserCodeTimerComponent} from '../user-code-timer/user-code-timer.component';

@Component({
  selector: 'app-codes-roller',
  imports: [
    PriceFormatPipe,
    UserCodeTimerComponent
  ],
  templateUrl: './codes-roller.component.html',
  styleUrl: './codes-roller.component.scss'
})
export class CodesRollerComponent implements AfterViewInit {
  items: InputSignal<CodesReelModel[]> = input.required();
  @Output() reserve = new EventEmitter<CodesReelModel>();

  @ViewChild('scroller', { static: true }) scrollerRef!: ElementRef<HTMLDivElement>;

  rowHeight = 60;
  paddingSide = 0;

  ngAfterViewInit() {
    this.updatePadding();
  }

  @HostListener('window:resize')
  onResize() {
    this.updatePadding();
  }

  private updatePadding() {
    const scroller = this.scrollerRef?.nativeElement;
    if (!scroller) return;
    this.paddingSide = Math.max(0, Math.floor(scroller.clientHeight / 2 - this.rowHeight / 2));
  }

  onReserveClick(ev: MouseEvent, item: CodesReelModel) {
    ev.stopPropagation();
    this.reserve.emit(item);
  }
}

